// extracted by mini-css-extract-plugin
module.exports = {"menu":"AccountMenu_menu__PIme4","link":"AccountMenu_link__E8TFM","link-active":"AccountMenu_link-active__1iaqB"};